import imageCompression from 'browser-image-compression';

export interface ImageConverter {
    convertAndCompress(file: File): Promise<File>;
}

export default class DefaultImageConverter implements ImageConverter {
    async convertAndCompress(file: File): Promise<File> {
        const options = {
            maxWidthOrHeight: 1920,
            useWebWorker: true,
            initialQuality: 0.8,
        };

        const compressedFile = await imageCompression(file, options);
        return new File([compressedFile], file.name.replace(/\.\w+$/, ".jpg"), {
            type: "image/jpeg",
        });
    }
}
